export * from './baMenuItem.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baMenu/components/baMenuItem/index.ts